/**
 * The locale short dates are rendered in.
 *
 * `en-CA` is not passed through: `Intl` renders it as `2026-03-08`, whereas Canadian centers expect
 * `08/03/2026`, which is what `en-GB` gives. Leaving the locale undefined would instead follow the
 * browser's own setting, so a Canadian guardian on a US-configured device would see US order.
 */
const CANADIAN_DATE_LOCALE = 'en-GB';
const DEFAULT_DATE_LOCALE = 'en-US';

/** From the app's i18n language, as `formatDocumentDate` receives it. */
export const toDateLocale = (language?: string): string => (language === 'en-CA' ? CANADIAN_DATE_LOCALE : DEFAULT_DATE_LOCALE);

/** From the center's country, which is what i18n derives the language from in the first place. */
export const dateLocaleForCountry = (countryCode?: string): string => (countryCode === 'CA' ? CANADIAN_DATE_LOCALE : DEFAULT_DATE_LOCALE);

/**
 * Day and month always take two digits. `en-GB` pads by default but `en-US` does not, so without
 * this a US guardian would read `8/21/2026` on one screen and `08/21/2026` on the next.
 */
export const SHORT_DATE_OPTIONS: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

export const formatShortDate = (date: Date, locale?: string): string => date.toLocaleDateString(locale, SHORT_DATE_OPTIONS);
